// extracted by mini-css-extract-plugin
export default {"zitate":"zitate_zitate__pGZ-f","author":"zitate_author__b-0qw"};